import Vuex from "vuex";
import userStore from "./modules/userStore";
import buyStepStore from "./modules/buyStepStore";
import markPriceStore from "./modules/markPriceStore";
import sellStepStore from "./modules/sellStepStore";
import assetStore from "./modules/assetStore";
import coreStore from "./modules/coreStore";
import tradeStore from "./modules/tradeStore";
import stopStore from "./modules/tradeStop";
import manualStore from "./modules/manualStore";

import buyConfigStore from "./modules/buyConfigStore";
import bottomStore from "./modules/bottomStore";

const store = new Vuex.Store({
  modules: {
    userStore: userStore,
    buyStore: buyStepStore,
    sellStore: sellStepStore,
    markPriceStore: markPriceStore,
    assetStore: assetStore,
    coreStore: coreStore,
    tradeStore: tradeStore,
    stopStore: stopStore,
    manualStore: manualStore,
    buyConfigStore: buyConfigStore,
    bottomStore: bottomStore,
  },
});

export default store;
